'use strict';

var namespace = 'productView:';

module.exports = {
  PRODUCT_CONFIGURATION_SELECTED: namespace + 'PRODUCT_CONFIGURATION_SELECTED',
  CUSTOM_MAKER_MODEL_SELECTED:    namespace + 'CUSTOM_MAKER_MODEL_SELECTED',
  PREVIEW_MAIN_IMAGE_SLIDESHOW: namespace + 'PREVIEW_MAIN_IMAGE_SLIDESHOW',
  SHAPE_JS_VIEWER_IS_AVAILABLE: namespace + 'SHAPE_JS_VIEWER_IS_AVAILABLE',
  SHAPE_JS_VIEWER_ACTIVATE: namespace + 'SHAPE_JS_VIEWER_ACTIVATE',
  SHAPE_JS_VIEWER_IS_ACTIVE: namespace + 'SHPAE_JS_VIEWER_IS_ACTIVE',
  SHAPE_JS_VIEWER_START_PREVENT_INTERACTION: namespace + 'SHAPE_JS_VIEWER_START_PREVENT_INTERACTION',
  SHAPE_JS_VIEWER_STOP_PREVENT_INTERACTION: namespace + 'SHAPE_JS_VIEWER_STOP_PREVENT_INTERACTION',
  SHAPE_JS_VIEWER_IS_LOADING: namespace + 'SHAPE_JS_VIEWER_IS_LOADING'
};
